import React from "react";
import { createPortal } from "react-dom";

/**
 * Modal de confirmación reutilizable (estilo Bootstrap).
 * Se renderiza en document.body para evitar problemas de z-index/stacking dentro del layout.
 */
export default function ConfirmModal({
	open,
	onClose,
	onConfirm,
	title = "Confirmar",
	message = "¿Continuar?",
	confirmLabel = "Confirmar",
	loading = false,
	confirmDisabled = false,
}) {
	const handleConfirm = () => {
		onConfirm();
	};

	const modal = !open ? null : (
		<div
			className="modal d-block"
			tabIndex={-1}
			role="dialog"
			aria-labelledby="confirmModalTitle"
			style={{
				position: "fixed",
				inset: 0,
				zIndex: 1060,
				backgroundColor: "rgba(0,0,0,.5)",
			}}
			onMouseDown={(e) => {
				if (e.target === e.currentTarget && !loading) onClose();
			}}
		>
			<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content shadow">
					<div className="modal-header">
						<h5 className="modal-title fw-semibold" id="confirmModalTitle">
							{title}
						</h5>
						<button
							type="button"
							className="btn-close"
							onClick={onClose}
							disabled={loading}
							aria-label="Cerrar"
						/>
					</div>
					<div className="modal-body">{message}</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn adm-del-btn"
							onClick={onClose}
							disabled={loading}
						>
							<span>Cancelar</span>
						</button>
						<button
							type="button"
							className={`btn adm-save-btn`}
							onClick={handleConfirm}
							disabled={loading || confirmDisabled}
						>
							<span>{loading ? "Procesando…" : confirmLabel}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);

	return modal ? createPortal(modal, document.body) : null;
}
